import type { Theme } from '@mui/material';
export const ADMIN_PROJECTS_TAG = 'ADMIN_PROJECTS';

export const STATUS_ICON_COLOR_MAPPING = (theme: Theme) => {
  return {
    draft: theme.palette.warning.main,
    inProgress: theme.palette.info.main,
    completed: theme.palette.success.main,
    refStdReview: theme.palette.warning.main,
    inActive: theme.palette.grey[500],
  };
};

/** Project status key sent by the API (see `_status_map` in `project_service.py`). */
export const PROJECT_STATUS_INACTIVE = 'inActive';

export const ADMIN_PROJECT_TABS = {
  OVERVIEW: 'overview',
  ALLOCATION: 'allocation',
} as const;

export type AdminProjectTabType = (typeof ADMIN_PROJECT_TABS)[keyof typeof ADMIN_PROJECT_TABS];

/**
 * Gates blocking edit access (action menu, overview button, `?edit=1` deep link) for a
 * project whose status is `PROJECT_STATUS_INACTIVE`.
 */
// TODO: cleanup with at_disable_edit_option_for_inactive_proj ff
export const DISABLE_EDIT_FOR_INACTIVE_PROJECT_FF = 'at_disable_edit_option_for_inactive_proj';
